import {
    ApiConstructor,
    ApiConstructorBlock,
    AppConstructor,
    ConstructorBlock,
} from '@/shared/components/constructor/Constructor/Constructor';

const map: Record<ApiConstructorBlock['block'], ConstructorBlock['name']> = {
    wysiwyg: 'text',
    image: 'image',
    video: 'video',
    quote: 'quote',
    'slider-images': 'slider',
    text: 'text',
    people: 'people',
    companies: 'companies',
};

export const transformConstructorFromApi = (data: ApiConstructor): AppConstructor =>
    data.map((item) => {
        return {
            name: map[item.block],
            properties: item.properties,
        };
    });
